import {
  GET_ATTENDANT_SETTINGS_REQUESTED,
  GET_ATTENDANT_SETTINGS_SUCCEEDED,
  GET_ATTENDANT_SETTINGS_FAILED,
  UPDATE_ATTENDANT_SETTING_SUCCEEDED,
  REMOVE_ATTENDANT_SETTING_SUCCEEDED,
  CREATE_ATTENDANT_SETTING_SUCCEEDED,
} from './constants'
import { get, keys, keyBy, omit, values, partition } from 'lodash'
import dataMapper from '../../utils/dataMapper'

export const defaultState = {}

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case CREATE_ATTENDANT_SETTING_SUCCEEDED: {
      const [eventConfigsPayload, configsPayload] = partition(payload, (config) => !!config.salesEventId)
      const byEmployeeId = keyBy(configsPayload, 'employeeUuid')
      const attendantSettings = values(state.byEmployeeId)
      const updatedAttendantSettings = [
        ...attendantSettings,
        ...values(byEmployeeId)
      ]
      const byStandUuid = dataMapper.staffByStandUuids(updatedAttendantSettings)
      const byEventId = dataMapper.byEventAndEmployeeId(eventConfigsPayload, false)
      const byEventIdCopy = { ...state.byEventId }

      keys(byEventId).forEach(eventId => {
        if (byEventIdCopy[eventId]) {
          byEventIdCopy[eventId].byEmployeeId = {
            ...byEventIdCopy[eventId].byEmployeeId,
            ...byEventId[eventId].byEmployeeId,
          }
          byEventIdCopy[eventId].byStandUuid = dataMapper.staffByStandUuids(values(byEventIdCopy[eventId].byEmployeeId))
        } else {
          byEventIdCopy[eventId] = {
            byEmployeeId: {
              ...byEventId[eventId].byEmployeeId,
            }
          }
          byEventIdCopy[eventId].byStandUuid = dataMapper.staffByStandUuids(values(byEventIdCopy[eventId].byEmployeeId))
        }
      })

      return {
        ...state,
        byEmployeeId: {
          ...state.byEmployeeId,
          ...byEmployeeId
        },
        byStandUuid,
        createdAttendantId: get(payload, [0, 'employeeUuid'], 'new'),
        byEventId: byEventIdCopy
      }
    }

    case GET_ATTENDANT_SETTINGS_REQUESTED: {
      return {
        ...state,
        isLoading: true
      }
    }

    case GET_ATTENDANT_SETTINGS_SUCCEEDED: {
      const [eventConfigsPayload, configsPayload] = partition(payload, (config) => !!config.salesEventId)
      const byEmployeeId = keyBy(configsPayload, 'employeeUuid')
      const byStandUuid = dataMapper.staffByStandUuids(configsPayload)
      const byEventId = dataMapper.byEventAndEmployeeId(eventConfigsPayload)
      return {
        ...state,
        isLoading: false,
        byEmployeeId,
        byStandUuid,
        byEventId
      }
    }

    case GET_ATTENDANT_SETTINGS_FAILED: {
      return {
        ...state,
        isLoading: false
      }
    }

    case REMOVE_ATTENDANT_SETTING_SUCCEEDED: {
      const editedState = omit(state.byEmployeeId, '')
      const byEmployeeId = keyBy(editedState, 'employeeUuid')

      return {
        ...state,
        byEmployeeId
      }
    }

    case UPDATE_ATTENDANT_SETTING_SUCCEEDED: {
      const [eventConfigsPayload, configsPayload] = partition(payload, (config) => !!config.salesEventId)
      const byEmployeeId = keyBy(configsPayload, 'employeeUuid')
      const attendantSettings = values(state.byEmployeeId)
      const updatedAttendantSettings = attendantSettings.map(attendantSetting => {
        const updatedByEmployeeId = keys(byEmployeeId)
        if (updatedByEmployeeId.includes(attendantSetting.employeeUuid)) {
          return byEmployeeId[attendantSetting.employeeUuid]
        }
        return attendantSetting
      })
      const byStandUuid = dataMapper.staffByStandUuids(updatedAttendantSettings)
      const byEventId = dataMapper.byEventAndEmployeeId(eventConfigsPayload, false)
      const byEventIdCopy = { ...state.byEventId }

      keys(byEventId).forEach((eventId) => {
        if(byEventIdCopy[eventId]){
          byEventIdCopy[eventId].byEmployeeId = {
            ...byEventIdCopy[eventId].byEmployeeId,
            ...byEventId[eventId].byEmployeeId
          }
          byEventIdCopy[eventId].byStandUuid = dataMapper.staffByStandUuids(values(byEventIdCopy[eventId].byEmployeeId))
        }
      })

      return {
        ...state,
        byEmployeeId: {
          ...state.byEmployeeId,
          ...byEmployeeId
        },
        byStandUuid,
        byEventId: byEventIdCopy
      }
    }

    default:
      return state
  }
}
